import axios from 'axios'
export default axios.create({
    baseURL: 'https://alza.web.id/tosmapi/',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
})